function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import moment from "moment";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var projectStatus = function projectStatus(status) {
  switch (status) {
    case "READY_TO_OCCUPY":
      return "Ready to Move";
    case "UNDER_CONSTRUCTION":
      return "Under Construction";
    case "NEWLY_LAUNCHED":
      return "Newly Launched";
    case "SOLD_OUT":
      return "Sold Out";
    case "READY_FOR_FIT_OUTS":
      return "Ready for Fit Outs";
    default:
      return status || "";
  }
};
export var currencyToIndianRsWord = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  notation: "compact",
  compactDisplay: "long"
});
export var copyCodeHandler = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var shareLink, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          console.log("Copyyyyyy");
          shareLink = isAuthenticated ? link : typeof window !== "undefined" ? window.location.href : "";
          if (!(typeof navigator !== "undefined" && navigator.clipboard)) {
            _context.n = 2;
            break;
          }
          _context.n = 1;
          return navigator.clipboard.writeText(shareLink);
        case 1:
          setCopiedUrl(true);
        case 2:
          _context.n = 4;
          break;
        case 3:
          _context.p = 3;
          _t = _context.v;
        case 4:
          return _context.a(2);
      }
    }, _callee, null, [[0, 3]]);
  }));
  return function copyCodeHandler() {
    return _ref.apply(this, arguments);
  };
}();
export var getFont = function getFont(client) {
  switch (client) {
    case "GODREJ":
      return {
        heading: "font-Helvetica_Medium",
        body: "font-Helvetica_Light"
      };
    case "MAHINDRA":
      return {
        heading: "font-SourceSansPro",
        body: "font-SourceSansPro"
      };
    case "EMBASSY":
      return {
        heading: "font-Gotham_Light",
        body: "font-Gotham_Book",
        secondary: "font-Gotham_XLight",
        thin: "font-Gotham_Thin",
        medium: "font-Gotham_Medium",
        bold: "font-Gotham_Bold"
      };
    case "SPRE":
      return {
        heading: "font-Gotham_Bold",
        body: "font-Metropolis",
        secondary: "font-Din_Medium",
        medium: "font-Gotham_Medium"
      };
    case "KRC":
      return {
        body: "font-Montserrat",
        heading: "font-PlayfairDisplay"
      };
    case "JP":
      return {
        heading: "font-Bebas_Regular",
        body: "font-Montserrat"
      };
    case "M3M":
      return {
        heading: "font-Marcellus",
        body: "font-Lato"
      };
    case "KC":
      return {
        heading: "font-Poppins",
        body: "font-Montserrat"
      };
    case "METRO":
      return {
        heading: "font-Gotham_Medium",
        secondary: "font-Gotham_Light",
        bold: "font-Bell"
      };
    case "SUSHMA":
      return {
        heading: "font-Futura_Heavy",
        body: "font-Gotham_Book",
        bold: "font-Gotham_Bold"
      };
    case "PURTI":
      return {
        heading: "font-Literata_Black",
        bold: "font-Literata_Extrabold",
        body: "font-Mulish"
      };
    case "HDFC":
      return {
        heading: "font-Helvetica_Regular",
        body: "font-Helvetica_Regular"
      };
    case "MAX":
      return {
        heading: "font-Optima",
        body: "font-Montserrat"
      };
    case "NAMAN":
      return {
        heading: "font-BebasNeue_Bold",
        medium: "font-Gotham_Medium",
        body: "font-Gotham_Light"
      };
    case "AJMERA":
      return {
        heading: "font-HelveticaNeue_Bold",
        body: "font-Gotham_Light",
        secondary: "font-Helvetica_Regular",
        medium: "font-Gotham_Medium"
      };
    case "BPTP":
      return {
        heading: "font-Marcellus",
        body: "font-Metropolis",
        bold: "font-Metropolis_Bold"
      };
    case "SMARTWORLDCARE":
      return {
        heading: "font-Bebas_Regular",
        secondary: "font-BebasNeue_Light",
        body: "font-OpenSans"
      };
    case "BIRLA":
      return {
        heading: "font-DINNextLTPro_Regular",
        secondary: "font-Lato_Light",
        body: "font-DINNextLTPro_Light",
        medium: "font-DINNextLTPro_Medium",
        thin: "font-DINNextLTPro_UltraLight"
      };
    case "MAYFAIR":
      return {
        heading: "font-Square721BT_Bold",
        body: "font-Poppins"
      };
    case "CHANDAK":
      return {
        heading: "font-Gotham_Bold",
        body: "font-Gotham_Book",
        medium: "font-Gotham_Medium"
      };
    case "OMSREE":
      return {
        heading: "font-Montserrat"
      };
    case "EDEN":
      return {
        heading: "font-Nephilm",
        body: "font-Montserrat"
      };
    case "RRINFRA":
      return {
        heading: "font-Literata_Medium",
        body: "font-Mulish"
      };
    default:
      return {
        heading: "font-Helvetica_Medium",
        body: "font-Helvetica_Medium"
      };
  }
};
export var getKYCStatus = function getKYCStatus(_ref2) {
  var winnreAuth = _ref2.winnreAuth,
    _ref2$refresh = _ref2.refresh,
    refresh = _ref2$refresh === void 0 ? false : _ref2$refresh;
  return winnreAuth({
    method: "GET",
    url: "/winnre/user/user/kyc-status".concat(refresh ? "?refresh=true" : "")
  });
};
export var getBankStatus = function getBankStatus(_ref3) {
  var winnreAuth = _ref3.winnreAuth;
  return winnreAuth({
    method: "GET",
    url: "/winnre/user/bank-account/verification-status"
  });
};
export function toIndianRs(number, showDashForZero) {
  return isNaN(parseInt(number)) || !parseInt(number) && showDashForZero ? "-" : "₹" + parseInt(number).toLocaleString("en-IN");
}
var REGEX = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;
export var LinkParagraph = function LinkParagraph(paragraph) {
  var paragraphArray = paragraph.split(" ");
  return /*#__PURE__*/_jsx("div", {
    children: paragraphArray.map(function (word) {
      return word.match(REGEX) ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("a", {
          href: word,
          target: "_blank",
          rel: "noreferrer noopener",
          className: "text-blue-400 break-words",
          style: {
            overflowWrap: "anywhere",
            wordBreak: "break-word"
          },
          children: word
        }), " "]
      }) : word + " ";
    })
  });
};
export function truncateText(text, limitOrBreakpoints) {
  if (!text) return "";
  var cleanText = text.replace(/\s+/g, " ").trim();

  // CASE 1: single number → apply to all devices
  if (typeof limitOrBreakpoints === "number") {
    if (cleanText.length <= limitOrBreakpoints) return cleanText;
    return cleanText.slice(0, Math.max(limitOrBreakpoints - 3, 0)).trimEnd() + "...";
  }

  // CASE 2: responsive object
  var width = typeof window !== "undefined" ? window.innerWidth : 1280;
  var breakpoints = Object.keys(limitOrBreakpoints).map(Number).sort(function (a, b) {
    return b - a;
  });
  var limit = limitOrBreakpoints[breakpoints[breakpoints.length - 1]];
  var _iterator = _createForOfIteratorHelper(breakpoints),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var bp = _step.value;
      if (width >= bp) {
        limit = limitOrBreakpoints[bp];
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (cleanText.length <= limit) return cleanText;
  return cleanText.slice(0, Math.max(limit - 1, 0)).trimEnd() + "...";
}
export var renderDate = function renderDate(date) {
  var includeSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var dateStr = moment(date).format("Do");
  var superScript = "";
  if (dateStr.includes("th")) {
    superScript = "th";
  } else if (dateStr.includes("rd")) {
    superScript = "rd";
  } else if (dateStr.includes("st")) {
    superScript = "st";
  } else {
    superScript = "nd";
  }
  return /*#__PURE__*/_jsxs("span", {
    children: [moment(date).format("DD"), includeSpace && /*#__PURE__*/_jsx(_Fragment, {
      children: "\xA0"
    }), /*#__PURE__*/_jsx("sup", {
      children: superScript
    }), moment(date).format(" MMM YYYY")]
  });
};
export var getCategoryIdByName = function getCategoryIdByName(name) {
  switch (name) {
    case "Member Benefits":
      return 1;
    case "Exclusive Move In Offers":
      return 2;
    case "Home Financing Deals":
      return 3;
    case "Digital Amenities":
      return 5;
  }
};
export var updateCartCount = function updateCartCount(setCartCount) {
  var setCartValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var isPoints = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (isPoints ? localStorage.getItem("cartData_reloyrewardpoints") : localStorage.getItem("cartData")) {
    var cartData = JSON.parse(isPoints ? localStorage.getItem("cartData_reloyrewardpoints") : localStorage.getItem("cartData"));
    setCartCount(cartData ? cartData.totalProduct : 0);
    if (cartData.totalProduct > 0 && setCartValue) {
      setCartValue(cartData.cartValues);
    }
  } else {
    setCartCount(0);
    setCartValue && setCartValue([]);
  }
};
export function truncate(str, no_words) {
  if (!str) return "";
  return str.split(" ").slice(0, no_words).join(" ");
}